import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
document.addEventListener('DOMContentLoaded', () => {
    [...document.querySelectorAll('.js-gdi-modularity-about-me')]
        .map(e => {
        var _a, _b;
        return ({
            root: ReactDOM.createRoot(e),
            aboutMeApiUri: (_a = e.getAttribute('data-about-me-api-uri')) !== null && _a !== void 0 ? _a : '',
            labels: JSON.parse((_b = e.getAttribute('data-labels')) !== null && _b !== void 0 ? _b : '{}'),
        });
    })
        .filter(({ aboutMeApiUri }) => aboutMeApiUri.length > 0)
        .forEach(({ root, aboutMeApiUri, labels }) => {
        root.render(_jsx(React.StrictMode, { children: _jsx(App, Object.assign({}, { aboutMeApiUri, labels })) }));
    });
});
